import { DiscountTargetType } from "@/lib/gql/__generated__/graphql";

import type { RowData } from "../../../discount-table";

/**
 * priceSetting 以外の RowData を生成する
 *
 * @param id
 * @param discountName
 * @param discountCode
 * @param discountPriceTotalAmount
 * @param discountPriceTotalLimitAmount
 * @returns Omit<RowData, 'priceSetting'>
 */
export const omittedPriceSettingConverter = (
	id: string,
	discountName: string,
	discountCode: string,
	discountPriceTotalAmount: number,
	inSale: boolean,
	discountPriceTotalLimitAmount?: number,
): Omit<RowData, "priceSetting"> => {
	return {
		id,
		discountName,
		discountCode,
		discountTotal: `¥${discountPriceTotalAmount.toLocaleString()} / ${discountPriceTotalLimitAmount ? "¥" + discountPriceTotalLimitAmount.toLocaleString() : "∞"}`,
		inSale,
	} satisfies Omit<RowData, "priceSetting">;
};

const DiscountTargetTypeMap = {
	[DiscountTargetType.PerPerson]: "お一人様",
	[DiscountTargetType.PerRoom]: "一部屋",
	[DiscountTargetType.PerGroup]: "団体様",
} as const;
/**
 * DiscountTargetType から DisplayText に変換
 */
export const discountTargetTypeConverter = (discountTargetType?: DiscountTargetType) => {
	return discountTargetType ? DiscountTargetTypeMap[discountTargetType] : "";
};
